/**
 * 引入 element-ui 插件
 */
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

export default (function() {
  Vue.use(ElementUI)
})()
